
function initWishlistNoCustomer()
{
  updateWishlistButtons(), initWishlistButtons()
}

function initWishlistButtons()
{
  if (0 == $j(".add-in-wishlist-js").length) return !1
    }

function showMessage()
{
  jQuery("#modalAddToWishlist").modal("toggle")
}

function hideMessage()
{
  jQuery("#modalAddToWishlist").modal("hide")
}

function updateWishlistButtons()
{
  try
  {
    if (null != $j.cookie(cookieName) && "__" != $j.cookie(cookieName) && "" != $j.cookie(cookieName))
      for (var e = String($j.cookie(cookieName)).split("__"), t = 0; t < e.length; t++) "" != e[t] && $j(".defbtn" + e[t]).length && ($j(".defbtn" + e[t]).parent().find(".added-wishbutton").show(), $j(".defbtn" + e[t]).hide())
        }
  catch (e)
  {}
}

function changeInputNameCartPage()
{
  $j(window).width() > 767 ? ($j(".input-mobile").attr("name", ""), $j(".input-desktop").attr("name", "updates[]")) : ($j(".input-mobile").attr("name", "updates[]"), $j(".input-desktop").attr("name", ""))
}

function debouncer(e, t)
{
  var o, t = t || 500;
  return function ()
  {
    var i = this,
        n = arguments;
    clearTimeout(o), o = setTimeout(function ()
                                    {
      e.apply(i, Array.prototype.slice.call(n))
    }, t)
  }
}

function slideColumn()
{
  $j("#leftColumn").length > 0 && ($j(window).resize(function ()
                                                     {
    window.innerWidth < 992 ? filtersHeight() : $j("#leftColumn").removeAttr("style")
  }), $j(".slide-column-close").addClass("position-fix"), $j(".slide-column-open").on("click", function (e)
                                                                                      {
    e.preventDefault(), $j("#leftColumn").addClass("column-open"), $j("body").css("top", -$j("body").scrollTop()), $j("body").addClass("no-scroll").append('<div class="modal-filter"></div>'), $j(".modal-filter").length > 0 && $j(".modal-filter").click(function ()
    {
      $j(".slide-column-close").trigger("click")
    })
  }), $j(".slide-column-close").on("click", function (e)
                                   {
    e.preventDefault(), $j("#leftColumn").removeClass("column-open"), $j(".modal-filter").unbind(), $j(".modal-filter").remove();
    var t = -1 * parseInt($j("body").css("top").replace("px", ""));
    $j("body").removeAttr("style"), $j("body").removeClass("no-scroll"), $j("body").scrollTop(t)
  }))
}

function filtersHeight()
{
  var e = $j("#leftColumn"),
      t = window.innerHeight,
      o = e.outerHeight(),
      i = parseInt(t - o);
  i < 0 && e.css(
    {
      "max-height": o + i,
      overflow: "auto",
      "overflow-x": "hidden"
    })
}

function countDown()
{
  $j("#countdown1").length > 0 && $j("#countdown1").countdown(
    {
      until: new Date(2015, 12, 1)
    })
}

function productCarousel(e, t, o, i, n, s)
{
  window.innerWidth || $j(window).width();
  var l = t > 0 ? t : 6,
      r = o > 0 ? o : 4,
      a = i > 0 ? i : o,
      c = n > 0 ? n : i,
      d = s > 0 ? s : 1;
  (e = e).parent().find(".carousel-products__button").length > 0 ? e.slick(
    {
      prevArrow: e.parent().find(".carousel-products__button .btn-prev"),
      nextArrow: e.parent().find(".carousel-products__button .btn-next"),
      dots: !0,
      infinite: !1,
      slidesToShow: l,
      slidesToScroll: l,
      responsive: [
        {
          breakpoint: 1770,
          settings:
          {
            slidesToShow: r,
            slidesToScroll: r
          }
        },
        {
          breakpoint: 992,
          settings:
          {
            slidesToShow: a,
            slidesToScroll: a
          }
        },
        {
          breakpoint: 768,
          settings:
          {
            slidesToShow: c,
            slidesToScroll: c
          }
        },
        {
          breakpoint: 480,
          settings:
          {
            slidesToShow: d,
            slidesToScroll: d
          }
        }]
    }) : e.slick(
    {
      slidesToShow: l,
      slidesToScroll: 1,
      speed: 500,
      responsive: [
        {
          breakpoint: 1770,
          settings:
          {
            slidesToShow: r,
            slidesToScroll: r
          }
        },
        {
          breakpoint: 992,
          settings:
          {
            slidesToShow: a,
            slidesToScroll: a
          }
        },
        {
          breakpoint: 768,
          settings:
          {
            slidesToShow: c,
            slidesToScroll: c
          }
        },
        {
          breakpoint: 480,
          settings:
          {
            slidesToShow: d,
            slidesToScroll: d
          }
        }]
    }), fixCarouselHover(e)
}

function productBigCarousel(e, t, o, i, n, s)
{
  window.innerWidth || $j(window).width();
  var l = t > 0 ? t : 6,
      r = o > 0 ? o : 4,
      a = i > 0 ? i : o,
      c = n > 0 ? n : i,
      d = s > 0 ? s : 1;
  (e = e).parent().find(".carousel-products__button").length > 0 ? e.slick(
    {
      prevArrow: e.parent().find(".carousel-products__button .btn-prev"),
      nextArrow: e.parent().find(".carousel-products__button .btn-next"),
      dots: !0,
      slidesToShow: l,
      slidesToScroll: l,
      responsive: [
        {
          breakpoint: 1770,
          settings:
          {
            slidesToShow: r,
            slidesToScroll: d
          }
        },
        {
          breakpoint: 992,
          settings:
          {
            slidesToShow: a,
            slidesToScroll: d
          }
        },
        {
          breakpoint: 768,
          settings:
          {
            slidesToShow: c,
            slidesToScroll: d
          }
        },
        {
          breakpoint: 480,
          settings:
          {
            slidesToShow: d,
            slidesToScroll: d
          }
        }]
    }) : e.slick(
    {
      slidesToShow: l,
      slidesToScroll: 1,
      speed: 500,
      responsive: [
        {
          breakpoint: 1770,
          settings:
          {
            slidesToShow: r,
            slidesToScroll: d
          }
        },
        {
          breakpoint: 992,
          settings:
          {
            slidesToShow: a,
            slidesToScroll: d
          }
        },
        {
          breakpoint: 768,
          settings:
          {
            slidesToShow: c,
            slidesToScroll: d
          }
        },
        {
          breakpoint: 480,
          settings:
          {
            slidesToShow: d,
            slidesToScroll: d
          }
        }]
    }), fixCarouselHover(e)
}

function mobileOnlyCarousel()
{
  var e = window.innerWidth || $j(window).width(),
      t = $j(".carousel-products-mobile");
  e < 480 && $j(".carousel-products-mobile").slick(
    {
      slidesToShow: 1,
      slidesToScroll: 1
    }), $j(window).resize(debouncer(function (e)
                                    {
    (window.innerWidth || $j(window).width()) < 480 ? t && t.length && t.slick(
      {
        slidesToShow: 1,
        slidesToScroll: 1
      }) : t.hasClass("slick-initialized") && t.slick("unslick")
  }))
}

function bannerCarousel(e)
{
  e.slick(
    {
      infinite: !1,
      dots: !1,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 768,
          settings:
          {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings:
          {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
    })
}

function bannerCarouselShort(e)
{
  e.slick(
    {
      infinite: !1,
      dots: !1,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 1200,
          settings:
          {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings:
          {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
    })
}

function blogCarousel(e, t, o, i, n, s)
{
  window.innerWidth || $j(window).width();
  var l = t > 0 ? t : 6,
      r = o > 0 ? o : 4,
      a = i > 0 ? i : o,
      c = n > 0 ? n : i,
      d = s > 0 ? s : 1;
  (e = e).parent().find(".carousel-products__button").length > 0 ? e.slick(
    {
      prevArrow: e.parent().find(".carousel-products__button .btn-prev"),
      nextArrow: e.parent().find(".carousel-products__button .btn-next"),
      dots: !1,
      infinite: !1,
      slidesToShow: l,
      slidesToScroll: l,
      responsive: [
        {
          breakpoint: 1770,
          settings:
          {
            slidesToShow: r,
            slidesToScroll: r
          }
        },
        {
          breakpoint: 992,
          settings:
          {
            slidesToShow: a,
            slidesToScroll: a
          }
        },
        {
          breakpoint: 768,
          settings:
          {
            slidesToShow: c,
            slidesToScroll: c
          }
        },
        {
          breakpoint: 480,
          settings:
          {
            slidesToShow: d,
            slidesToScroll: d
          }
        }]
    }) : e.slick(
    {
      slidesToShow: l,
      slidesToScroll: 1,
      speed: 500,
      responsive: [
        {
          breakpoint: 1770,
          settings:
          {
            slidesToShow: r,
            slidesToScroll: r
          }
        },
        {
          breakpoint: 992,
          settings:
          {
            slidesToShow: a,
            slidesToScroll: a
          }
        },
        {
          breakpoint: 768,
          settings:
          {
            slidesToShow: c,
            slidesToScroll: c
          }
        },
        {
          breakpoint: 480,
          settings:
          {
            slidesToShow: d,
            slidesToScroll: d
          }
        }]
    })
}

function bannerAsid(e)
{
  e.slick(
    {
      infinite: !1,
      dots: !0,
      arrows: !1,
      slidesToShow: 1,
      slidesToScroll: 1
    })
}

function testimonialsAsid(e)
{
  e.slick(
    {
      infinite: !1,
      dots: !0,
      arrows: !1,
      slidesToShow: 1,
      slidesToScroll: 1
    })
}

function brandsCarousel(e)
{
  e.slick(
    {
      infinite: !1,
      dots: !1,
      slidesToShow: 6,
      slidesToScroll: 10,
      responsive: [
        {
          breakpoint: 1770,
          settings:
          {
            slidesToShow: 6,
            slidesToScroll: 6
          }
        },
        {
          breakpoint: 1199,
          settings:
          {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 768,
          settings:
          {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings:
          {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
    })
}

function verticalCarousel(e, t)
{
  var t = t > 0 ? t : 2;
  e.slick(
    {
      infinite: !1,
      dots: !1,
      slidesToShow: t,
      slidesToScroll: t,
      vertical: !0
    })
}

function thumbnailsCarousel(e)
{
  e.slick(
    {
      infinite: !1,
      dots: !1,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings:
          {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 992,
          settings:
          {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }]
    })
}

function fixCarouselHover(e)
{
  e.find(".slick-slide").bind("mouseenter mouseleave", function (e)
                              {
    $j(this).closest(".slick-slider").toggleClass("hover")
  })
}

function elevateZoom()
{
  var e = window.innerWidth || document.documentElement.clientWidth;
  $j(".product-zoom").imagesLoaded(function ()
                                   {
    if ($j(".product-zoom").length)
    {
      var t;
      t = "rtl" == $j("html").css("direction").toLowerCase() ? 11 : 1, e > 767 ? $j(".product-zoom").elevateZoom(
        {
          zoomWindowWidth: $j(".product-zoom").width() - 60,
          zoomWindowHeight: $j(".product-zoom").width() - 60,
          gallery: "smallGallery",
          galleryActiveClass: "active",
          zoomWindowPosition: t
        }) : $j(".product-zoom").elevateZoom(
        {
          gallery: "smallGallery",
          zoomType: "inner",
          galleryActiveClass: "active",
          zoomWindowPosition: t
        })
    }
  }), $j(".product-main-image > .product-main-image__zoom ").bind("click", function ()
                                                                  {
    if (galleryObj = [], current = 0, itemN = 0, $j("#smallGallery").length) console.log("1"), $j("#smallGallery li a").not(".video-link").each(function ()
                                                                                                                                                {
      $j(this).hasClass("active") && (current = itemN), itemN++;
      var e = $j(this).data("zoom-image");
      image = {}, image.src = e, image.type = "image", galleryObj.push(image)
    });
    else
    {
      console.log("2"), itemN++;
      var e = $j(this).parent().find(".product-zoom").data("zoom-image");
      image = {}, image.src = e, image.type = "image", galleryObj.push(image)
    }
    $j.magnificPopup.open(
      {
        items: galleryObj,
        gallery:
        {
          enabled: !0
        }
      }, current)
  });
  var t = e;
  $j(window).resize(debouncer(function (e)
                              {
    var o = window.innerWidth || $j(window).width();
    o != t && ($j(".zoomContainer").remove(), $j(".elevatezoom").removeData("elevateZoom"), $j(".product-zoom").length && (o > 767 ? $j(".product-zoom").elevateZoom(
      {
        zoomWindowHeight: $j(".product-zoom").height(),
        gallery: "smallGallery"
      }) : $j(".product-zoom").elevateZoom(
      {
        gallery: "smallGallery",
        zoomType: "inner"
      }))), t = window.innerWidth || $j(window).width()
  }))
}

function elevateZoom1()
{
  (window.innerWidth || $j(window).width()) > 767 && $j(".product-zoom1").length && $j(".product-zoom1").elevateZoom(
    {
      zoomType: "inner",
      cursor: "crosshair",
      zoomWindowFadeIn: 300,
      zoomWindowFadeOut: 300
    })
}

function setProductSize()
{
  (window.innerWidth || $j(window).width()) > 767 && $j(".product").each(function ()
                                                                         {
    var e = $j(this).outerHeight();
    $j(this).css(
      {
        "min-height": e + "px"
      }), $j(this).find(".product__inside").addClass("pos-abs")
  }), $j(window).resize(function (e)
                        {
    $j(".product").each(function ()
                        {
      $j(this).css(
        {
          "min-height": ""
        }), $j(this).find(".product__inside__info").css(
        {
          height: "0"
        }), $j(this).find(".product__inside").removeClass("pos-abs")
    });
    var t;
    clearTimeout(t), t = setTimeout(function ()
                                    {
      var e = window.innerWidth || $j(window).width();
      $j(".product").each(function ()
                          {
        if ($j(this).find(".product__inside__info").css(
          {
            height: ""
          }), e > 767)
        {
          var t = $j(this).outerHeight();
          $j(this).css(
            {
              "min-height": t + "px"
            }), $j(this).find(".product__inside").addClass("pos-abs")
        }
      })
    }, 1e3)
  })
}

function navbarClick()
{
  (window.innerWidth || $j(window).width()) > 1025 && $j(".navbar .dropdown > a").on("click", function ()
                                                                                     {
    return location.href = this.href, !1
  })
}

function setProductArrows()
{
  var e = window.innerWidth || $j(window).width(),
      t = function (e)
  {
    if (e > 1199)
    {
      var t = $j(".product-main-image img").height();
      $j("#productPrevNext > a").css(
        {
          top: t / 2 + "px"
        })
    }
  };
  t(e), $j(window).resize(debouncer(function (e)
                                    {
    var o = window.innerWidth || $j(window).width();
    t(o)
  }))
}

function setCarouselArrows()
{
  var e = window.innerWidth || $j(window).width(),
      t = function (e)
  {
    e < 480 ? ($j(".carousel-products-mobile.slick-initialized").length || $j(".carousel-products.slick-initialized").length) && ($j(".carousel-products-mobile").each(function ()
      {
      var e = $j(this).find(".slick-list .slick-track .slick-slide:first-child img").height();
      $j(this).find(".slick-arrow").css(
        {
          top: e / 2 + "px"
        })
    }), $j(".carousel-products").each(function ()
                                      {
      if ($j(this).parent().parent().find(".carousel-products__button").length > 0)
      {
        var e = $j(this).find(".slick-list .slick-track .slick-slide:first-child img").height(),
            t = $j(this).parent().parent().find(".title-with-button").height();
        $j(this).parent().parent().find(".carousel-products__button").css(
          {
            top: e / 2 + t + "px"
          })
      }
    })) : $j(".carousel-products").each(function ()
                                        {
      if ($j(this).parent().parent().find(".carousel-products__button").length > 0) $j(this).parent().parent().find(".carousel-products__button").css(
        {
          top: ""
        });
      else
      {
        var e = $j(this).find(".slick-list .slick-track .slick-slide:first-child img").height();
        $j(this).find(".slick-arrow").css(
          {
            top: e / 2 + "px"
          })
      }
    })
  };
  t(e), $j(window).resize(debouncer(function (e)
                                    {
    var o = window.innerWidth || $j(window).width();
    t(o)
  }))
}

function setMobileDrop()
{
  var e, t = $j("body").innerWidth();
  (e = function (e)
   {
    e < 1025 ? $j(".dropdown-menu--xs-full").each(function ()
                                                  {
      $j(this).css(
        {
          width: e + "px"
        })
    }) : $j(".dropdown-menu--xs-full").each(function ()
                                            {
      $j(this).css(
        {
          width: ""
        })
    })
  })(t), $j(window).resize(debouncer(function (t)
                                     {
    var o = $j("body").innerWidth();
    e(o)
  }))
}

function handlerDropDownClose()
{
  $j(".dropdown-menu__close").on("click", function (e)
                                 {
    e.preventDefault(), $j(this).closest(".dropdown.open .dropdown-toggle").dropdown("toggle")
  })
}

function searchDropDown()
{
  $j(".search__open").on("click", function (e)
                         {
    e.preventDefault(), $j(this).parent(".search").addClass("open"), $j(this).next(".search-dropdown").addClass("open"), $j("header .badge").addClass("badge--hidden")
  }), $j(".search__close").on("click", function (e)
                              {
    e.preventDefault(), $j(this).closest(".search").removeClass("open"), $j(this).closest(".search-dropdown").removeClass("open"), $j("header .badge").removeClass("badge--hidden")
  })
}

function footerCollapse()
{
  $j(".mobile-collapse__title").on("click", function (e)
                                   {
    e.preventDefault, $j(this).parent(".mobile-collapse").toggleClass("open")
  })
}

function productInsideCarousel()
{
  $j(".product__inside__carousel").each(function ()
                                        {
    var e = $j(this);
    e.hasClass("isInit") || (e.addClass("isInit"), e.carousel(
      {
        interval: !1
      }), e.find(".carousel-control.next").on("click", function ()
                                              {
      e.carousel("next")
    }), e.find(".carousel-control.prev").on("click", function ()
                                            {
      e.carousel("prev")
    }))
  })
}

function expanderList()
{
  $j(".expander-list .expander").each(function ()
                                      {
    $j(this).parent("li").hasClass("active") && ($j(this).next("ul").slideDown(0), $j(this).parent().addClass("open"))
  }), $j(".expander-list .expander, .name").on("click", function (e)
                                               {
    e.preventDefault;
    var t = $j(this).parent(),
        o = $j(this).next("ul");
    t.hasClass("open") ? (t.removeClass("open"), o.slideUp(300)) : (t.addClass("open"), o.slideDown(300))
  })
}

function collapseBlock()
{
  $j(".collapse-block__content").each(function ()
                                      {
    $j(this).parent(".collapse-block").hasClass("open") && $j(this).slideDown(0)
  }), $j(".collapse-block__title").on("click", function (e)
                                      {
    e.preventDefault;
    var t = $j(this).parent(),
        o = $j(this).next(".collapse-block__content");
    t.hasClass("open") ? (t.removeClass("open"), o.slideUp(300)) : (t.addClass("open"), o.slideDown(300))
  })
}

function priceSlider()
{
  if ($j(".price-slider").length)
  {
    var e = document.getElementById("priceSlider");
    noUiSlider.create(e,
                      {
      start: [100, 900],
      connect: !0,
      step: 1,
      range:
      {
        min: 0,
        max: 1e3
      }
    });
    var t = document.getElementById("priceMax"),
        o = document.getElementById("priceMin");
    e.noUiSlider.on("update", function (e, i)
                    {
      var n = e[i];
      i ? t.value = n : o.value = n
    }), t.addEventListener("change", function ()
                           {
      e.noUiSlider.set([null, this.value])
    }), o.addEventListener("change", function ()
                           {
      e.noUiSlider.set([this.value, null])
    })
  }
}

function listingModeToggle()
{
  $j("a.link-row-view").on("click", function (e)
                           {
    e.preventDefault(), $j(this).addClass("active"), $j("a.link-grid-view").removeClass("active"), $j(".product-listing").addClass("row-view")
  }), $j("a.link-grid-view").on("click", function (e)
                                {
    e.preventDefault(), $j(this).addClass("active"), $j("a.link-row-view").removeClass("active"), $j(".product-listing").removeClass("row-view")
  })
}

function backToTop(){
  $j('.back-to-top').click(function(){
    $j('body,html').animate(
      {'scrollTop':0},
      600);
  });
  var initialPosition = $j(window).scrollTop(); //save the top most scroll position or your scroll position when you load the site
  var getBannerOuterHeight = $j('.moto-cd-hero').outerHeight();

  $j(window).scroll(function(){
    if($j(this).scrollTop()<=getBannerOuterHeight+200){
      $j('.back-to-top').fadeOut(600);
      $j('#backToTop').fadeOut(600);
    }
    else{
      var currentScrollPosition = $j(window).scrollTop();//save the  scroll position or your scroll position when you scroll the site
      if(currentScrollPosition>initialPosition){
        if($j(this).scrollTop()>150){
          if( $j('.back-to-top').is(":visible")){
            $j('.back-to-top').hide();
            $j('#backToTop').hide();
          }
          else{
            $j(this).scrollTop()
            $j('.back-to-top').fadeOut(600);
            $j('#backToTop').fadeOut(600);
          }
        }
      }
      else if($j(this).scrollTop()>150){
        $j('.back-to-top').fadeIn(300);
        $j('#backToTop').fadeIn(300);
      }
    }
    initialPosition = currentScrollPosition;
  });
}

// function backToTop()
// {
//  $j(".back-to-top").length > 0 && ($j(".back-to-top").click(function ()
//  {
//    return $j("html, body").animate(
//    {
//      scrollTop: 0
//    }, 500), !1
//  }), $j(window).scroll(function ()
//  {
//    $j(window).scrollTop() > 500 ? $j(".back-to-top").stop((!0).false).fadeIn(110) : $j(".back-to-top").stop((!0).false).fadeOut(110)
//  }))
// }

function stuckNav()
{
  $j(".stuck-nav").length > 0 && ($j(".header-layout-02").length && window.innerWidth, HeaderTop = $j(".stuck-nav").offset().top, $j(window).scroll(function ()
                                                                                                                                                    {
    checkStickyPosition(), !!$j(".header-layout-02").length && stickNav()
  }), $j(window).resize(function ()
                        {
    HeaderTop = $j("#pageContent").offset().top, checkStickyPosition(), !!$j(".header-layout-02").length && ($j(".stuck-nav").length && window.innerWidth <= 1024 ? $j(".stuck-nav").show() : stickNav())
  }), checkStickyPosition())
}

function checkStickyPosition()
{
  $j(window).scrollTop() > HeaderTop ? $j(".stuck-nav").addClass("fixedbar") : $j(".stuck-nav").removeClass("fixedbar") && $j("#fixedtog").removeClass("in")
}

function stickNav()
{
  $j(".stuck-nav").length && window.innerWidth > 1024 && ($j(window).scrollTop() > $j("#header").innerHeight() ? $j(".stuck-nav").show() : $j(".stuck-nav").hide())
}

function cartSlideIni()
{
  $j("header .cart").length > 0 && ($j("header .cart .dropdown-toggle").on("click", function (e)
                                                                           {
    $j("header .cart .dropdown-menu ul li").length && ($j("header .cart .dropdown").toggleClass("open"), headerCartSize()), e.preventDefault()
  }), $j("header .cart .cart__close").on("click", function (e)
                                         {
    $j("header .cart .dropdown").toggleClass("open"), e.preventDefault()
  }))
}

function blogPostSlider()
{
  $j(".blogPostSlider").length > 0 && $j(".blogPostSlider").slick(
    {
      infinite: !1,
      slidesToShow: 1
    })
}

function inputCounter()
{
  $j(".input-counter").length > 0 && ($j(".minus-btn").click(function ()
                                                             {
    var e = $j(this).parent().find("input"),
        t = parseInt(e.val()) - 1;
    return t = t < 1 ? 1 : t, e.val(t), e.change(), !1
  }), $j(".plus-btn").click(function ()
                            {
    var e = $j(this).parent().find("input");
    return e.val(parseInt(e.val()) + 1), e.change(), !1
  }))
}

function sliderNoZoom()
{
  $j(".slider-no-zoom").length > 0 && ($j(".slider-product-large").slick(
    {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: !1,
      fade: !0,
      centerPadding: "40px",
      infinite: !1,
      asNavFor: ".slider-product-small"
    }), $j(".slider-product-small").slick(
    {
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: !1,
      asNavFor: ".slider-product-large",
      dots: !0,
      centerPadding: "40px",
      focusOnSelect: !0
    }))
}

function productTabsCarousel(e, t, o, i, n, s)
{
  window.innerWidth || $j(window).width();
  var l = t > 0 ? t : 6;
  (e = e).parent().find(".carousel-products__button").length > 0 ? e.slick(
    {
      prevArrow: e.parent().find(".carousel-products__button .btn-prev"),
      nextArrow: e.parent().find(".carousel-products__button .btn-next"),
      dots: !0,
      slidesToShow: l,
      slidesToScroll: l,
      settings: "unslick"
    }) : e.slick(
    {
      slidesToShow: l,
      slidesToScroll: 1,
      speed: 500,
      settings: "unslick"
    }), fixCarouselHover(e)
}

function initTabsGallery()
{
  $j(".nav-tabs--ys-center a").each(function ()
                                    {
    $j(this).click(function ()
                   {
      $j(this).unbind();
      var e = $j(this).attr("href"),
          t = e + "-clone";
      $j(e).empty(), $j(t).children().clone().appendTo($j(e));
      var o = $j(e).find(".carouselTab");
      o.css("visibility", "hidden"), o.length && setTimeout(function ()
                                                            {
        productCarousel(o, 6, 4, 3, 2, 1), o.hide(), o.css("visibility", "visible"), o.fadeIn(500)
      }, 5)
    })
  })
}

function initListingGalleryEvent()
{
  $j(".coll-products-js").click(function ()
                                {
    $j(this).unbind(), listingGalleryEventHandler()
  })
}

function listingGalleryEventHandler(){
  $j(".coll-gallery").empty(), $j(".coll-gallery-clone").children().clone().appendTo(".coll-gallery"), verticalCarousel($j(".coll-gallery .vertical-carousel-2"), 4);
                                                                                                                        }

                                                                                                                        function submenuXposition(e)
  {
    var t = window.innerWidth,
        o = e.offset().left,
        i = e.outerWidth(),
        n = parseInt(t - o - i - 25);
    n < 0 && e.css("left", n)
  }

  function submenuYposition(e)
  {
    var t = window.innerHeight,
        o = $j(".stuck-nav").hasClass("fixedbar") ? e.position().top : e.offset().top,
        i = e.outerHeight(),
        n = parseInt(t - o - i);
    n < 0 && e.css(
      {
        "max-height": i + n - 25,
        overflow: "auto"
      })
  }

  function menuScroll(e)
  {
    e.data.obj.removeAttr("style"), submenuXposition(e.data.obj)
  }

  function removeActiveItem(e)
  {
    e.removeClass("active"), e.removeAttr("style")
  }

  function l9rectangle()
  {
    var e = $j(".l9-one-product-js");
    e.find(".row").removeAttr("style"), setTimeout(function ()
                                                   {
      var t = window.innerHeight,
          o = e.offset().top,
          i = e.outerHeight(),
          n = parseInt(t - o - i);
      n > 0 && e.find(".row").css("padding-bottom", n)
    }, 100)
  }

  function headerCartSize()
  {
    $cart.length && ($cart.find(".dropdown-menu").scrollTop(0), cartHeight())
  }

  function cartHeight()
  {
    var e = $cart.find(".dropdown-menu"),
        t = window.innerHeight,
        o = e.outerHeight(),
        i = parseInt(t - o);
    i < 0 && e.css(
      {
        "max-height": o + i,
        overflow: "auto",
        "overflow-x": "hidden"
      })
  }

  function initProductHover()
  {
    $j(".no-touch .product--zoom").unbind(), $j(".no-touch .product--zoom").each(function ()
                                                                                 {
      $j(this).hover(function (e)
                     {
        window.innerWidth > 1298 && 0 == $j(".row-view").length && ($j(this).css(
          {
            height: $j(this).innerHeight() + "px"
          }), $j(this).addClass("hovered"))
      }, function ()
                     {
        window.innerWidth > 1298 && 0 == $j(".row-view").length && ($j(this).css(
          {
            height: ""
          }), $j(this).removeClass("hovered"))
      })
    })
  }

  function initProductOptions()
  {
    $j(".productitem-color-js").length && $j(".productitem-color-js").each(function ()
                                                                           {
      $j(this).find("a").each(function ()
                              {
        $j(this).unbind(), $j(this).click(function (e)
                                          {
          e.preventDefault();
          var t = $j(this);
          if (t.parent().hasClass("active")) return !1;
          setNewData(t);
          var o = "." + t.attr("href") + "-js",
              i = $j("." + t.attr("pr_id"));
          i.find(".options-swatch--size").length && i.find(".options-swatch--size li").each(function ()
                                                                                            {
            $j(this).hide(), $j(this).removeClass("active")
          }), i.find(o).length && (i.find(o).first().addClass("active"), i.find(o).show())
        })
      })
    }), $j(".productitem-size-js").length && $j(".productitem-size-js").each(function ()
                                                                             {
      $j(this).find("a").each(function ()
                              {
        $j(this).unbind(), $j(this).click(function (e)
                                          {
          e.preventDefault();
          var t = $j(this);
          if (t.parent().hasClass("active")) return !1;
          setNewData(t)
        })
      })
    })
  }

  function setNewData(e)
  {
    e.parent().parent().find(".active").removeClass("active"), e.parent().addClass("active");
    var t = $j("." + e.attr("pr_id"));
    if (0 == t.find(".product__inside__carousel").length)
    {
      var o = e.attr("img");
      "" != o && t.find("img").first().attr("src", o)
    }
    t.find(".addtocart-js").attr("onclick", "Shopify.addItem(" + e.attr("var_id") + ", 1)"), $j(".button_massage").length && t.find(".addtocart-js").html($j(".button_massage").html()), t.find(".product__inside__price").html('<span class="money">' + e.attr("price") + "</span>"), $j(".currency .active").trigger("click")
  }
  var $j = jQuery.noConflict(),
      cookieName = "wishlistList";
  $j(document).ready(function ()
                     {
    $j(".image-links-layout .figure").length > 0 && $j(".image-links-layout .figure").each(function ()
                                                                                           {
      var e = $j(this),
          t = e.find(".btn");
      t.css("left", parseInt((e.innerWidth() - t.innerWidth()) / 2) + "px")
    })
  }), $j(window).resize(function ()
                        {
    $j("#cboxClose").length && window.innerWidth > 1024 && $j("#cboxClose").trigger("click")
  }), $j(window).bind("initWishlistNoCustomer", initWishlistNoCustomer), initWishlistNoCustomer(), $j(document).on("click", ".add-in-wishlist-js", function (e)
                                                                                                                   {
    try
    {
      var t = $j(this).attr("my-handle");
      if (null == $j.cookie(cookieName)) o = t;
      else if (-1 == $j.cookie(cookieName).indexOf(t)) var o = $j.cookie(cookieName) + "__" + t;
      $j.cookie(cookieName, o,
                {
        expires: 7,
        path: "/"
      }), "active" != $j(this).attr("nj-wishlist") && (showMessage(), setTimeout(hideMessage, 6e3));
      var i = $j(this).parent().parent();
      i.find(".default-wishbutton").hide(), i.find(".added-wishbutton").show(), updateWishlistButtons()
    }
    catch (e)
    {
      console.log(e)
    }
  }), $j("#rightColumn").length > 0 && ($j(window).resize(function ()
                                                          {
    if (window.innerWidth < 992)
    {
      if ($j("#leftColumn").children().length && 0 == $j("#rightColumn").children().length) return !1;
      e = $j("#rightColumn .sidebar-content").detach();
      $j("#leftColumn").append(e)
    }
    else
    {
      if ($j("#rightColumn").children().length > 1) return !1;
      var e = $j("#leftColumn .sidebar-content").detach();
      $j("#rightColumn").append(e)
    }
  }), $j(window).trigger("resize")), $j(".image-links-prototypes").length && $j(".image-links-prototypes").each(function ()
                                                                                                                {
    $j(this).parent().addClass("image-links-prototypes")
  }), $j(".input-mobile").length && $j(".input-desktop").length && (changeInputNameCartPage(), $j(window).resize(changeInputNameCartPage)), $j(window).bind("reinitSliderInProduct", productInsideCarousel);
  var HeaderTop = "";
  jQuery(function (e)
         {
    e(".header-layout-06 ").length > 0 && (e(".header-layout-06 .icon-search").click(function ()
                                                                                     {
      e(".header-layout-06 .alignment-extra").toggleClass("width-extra")
    }), e(".header-layout-06 .icon-close").click(function ()
                                                 {
      e(".header-layout-06 .alignment-extra").toggleClass("width-extra")
    }))
  }), jQuery(function (e)
             {
    e(".gallery").length && e(".gallery .zomm-gallery").magnificPopup(
      {
        type: "image",
        gallery:
        {
          enabled: !0
        }
      })
  }), jQuery(function (e)
             {
    var t = "";
    e(".filter-nav a").click(function ()
                             {
      e("#all-filter-content").hide(0), e("#all-filter-content").fadeIn(500), e(".filter-nav a").removeClass("current"), e(this).addClass("current"), t = e(this).attr("rel"), e(".filter-content-item").not("." + t).fadeOut(), e("." + t).fadeIn(), e("#all-filter-content").fadeIn(0)
    })
  }), $j(document).ready(function ()
                         {
    navbarClick(), countDown(), setMobileDrop(), handlerDropDownClose(), searchDropDown(), footerCollapse(), productInsideCarousel(), expanderList(), collapseBlock(), priceSlider(), slideColumn(), backToTop(), stuckNav(), blogPostSlider(), cartSlideIni(), inputCounter(), $j("body").addClass("loaded");
    var e;
    clearTimeout(e), e = setTimeout(function () {}, 500);
    var t;
    clearTimeout(t), t = setTimeout(function ()
                                    {
      setCarouselArrows(), $j("#productPrevNext").length && setProductArrows()
    }, 2e3)
  }), $j(window).resize(debouncer(function (e)
                                  {
    elevateZoom1()
  })), jQuery(function (e)
              {
    e(".davz-burger-menu").length && e(".davz-burger-menu .simple-icon-menu, .davz-burger-menu .close").click(function ()
                                                                                                              {
      e(".davz-burger-menu .dropdown-menu").slideToggle("fast")
    })
  }), jQuery(function (e)
             {
    e(".toggle-menu").length && e(".toggle-menu .simple-icon, .toggle-menu .close").click(function ()
                                                                                          {
      e(".toggle-menu .dropdown-menu").slideToggle("fast")
    })
  }), jQuery(function (e)
             {
    e(".image-bg").length && e(".image-bg").each(function ()
                                                 {
      var t = e(this).attr("data-image");
      e(this).css(
        {
          "background-image": "url(" + t + ")"
        })
    })
  }), jQuery(function (e)
             {
    e(".content--parallax").length && e(".content--parallax").each(function ()
                                                                   {
      var t = e(this).attr("data-image");
      e(this).css(
        {
          "background-image": "url(" + t + ")"
        }).parallax("50%", .01)
    })
  }), jQuery(function (e)
             {
    if ($j("#off-canvas-menu").length > 0)
    {
      $j(document).bind("cbox_open", function ()
                        {
        $j("body").css("top", -$j("body").scrollTop()), $j("body").addClass("no-scroll")
      }).bind("cbox_closed", function ()
              {
        var e = -1 * parseInt($j("body").css("top").replace("px", ""));
        $j("body").removeAttr("style"), $j("body").removeClass("no-scroll"), $j("body").scrollTop(e)
      });
      var t = $j("body").hasClass("rtl") ? "none" : "0",
          o = $j("body").hasClass("rtl") ? "0" : "none";
      $j("#off-canvas-menu-toggle").colorbox(
        {
          inline: !0,
          opacity: .55,
          transition: "none",
          arrowKey: !1,
          width: "300",
          height: "100%",
          fixed: !0,
          className: "canvas-menu",
          top: 0,
          right: o,
          left: t,
          colorBoxCartPos: 0
        })
    }
  }), jQuery(function (e)
             {
    e("#off-canvas-menu .expander-list").find("ul").hide().end().find(" .expander").text("+").end().find(".active").each(function ()
                                                                                                                         {
      e(this).parents("li ").each(function ()
                                  {
        var t = e(this),
            o = t.find("> ul"),
            i = t.find("> .name .expander");
        o.show(), i.html("&minus;")
      })
    }).end().find(" .expander").each(function ()
                                     {
      var t = e(this),
          o = "+" === t.text(),
          i = t.parent(".name").next("ul");
      t.next("a");
      t.click(function ()
              {
        "block" == i.css("display") ? i.slideUp("slow") : i.slideDown("slow"), e(this).html(o ? "&minus;" : "+"), o = !o
      });

    });

  })
  jQuery(function (e){
    e('.name').click(function(){ 
      if(e(this).hasClass('open')){
        e(this).removeClass('open');
      }
      else{
        e(this).addClass('open');
      }
      var expanderSelector = "+" === e(this).find('.expander').text();
      e(this).find('.expander').html(expanderSelector ? "&minus;" : "+");
    });
    e('.expander').click(function(){
      if(e(this).parent().hasClass('open')){

        e(this).parent().removeClass('open'); 
      }
      else{
        e(this).parent().addClass('open');  
      }
    });
  }), $j(".nav-tabs--ys-center").length && (initTabsGallery(), $j(".nav-tabs--ys-center .active a").trigger("click"), $j(window).resize(function ()
                                                                                                                                        {
    $j(".nav-tabs--ys-center a").unbind(), initTabsGallery()
  })), $j(".coll-products-js").length && ($j(".coll-products-js").hasClass("open") ? listingGalleryEventHandler() : initListingGalleryEvent(), $j(window).resize(function ()
{
    $j(".coll-products-js").unbind(), initListingGalleryEvent(), $j(".coll-products-js").hasClass("open") && listingGalleryEventHandler()
  }));
  var timerVar;
  $j("nav").each(function ()
                 {
    $j(this).hasClass("navbar-vertical") || $j(this).find(".dropdown").each(function ()
                                                                            {
      $j(this).hover(function ()
                     {
        var e = $j(this),
            t = e.find(".dropdown-menu");
        t.length && (t.fadeOut(0), timerVar = setTimeout(function ()
                                                         {
          e.addClass("active"), t.fadeIn(0), submenuXposition(t), $j(window).bind("scroll",
                                                                                  {
            obj: t
          }, menuScroll)
        }, 0))
      }, function ()
                     {
        var e = $j(this),
            t = e.find(".dropdown-menu");
        clearTimeout(timerVar), $j(window).unbind("scroll", menuScroll), e.hasClass("active") && (t.fadeOut(0), setTimeout(removeActiveItem, 0, e))
      })
    })
  }), $j("nav .dropdown-toggle[href='" + window.location.pathname + "']").length && $j("nav .dropdown-toggle[href='" + window.location.pathname + "']").parent().addClass("selected"), jQuery(function (e)
{
    $j(".responsive-menu .dropdown-mega-menu").doubleTapToGo()
  }), $j(".l9-one-product-js").length && (l9rectangle(), $j(window).resize(l9rectangle));
  var $cart = $j(".cart");
  $j(window).resize(headerCartSize), jQuery(function (e)
                                            {
    e(".content--parallax, .carusel--parallax").length && e(".content--parallax, .carusel--parallax").each(function ()
                                                                                                           {
      var t = e(this).attr("data-image");
      e(this).css(
        {
          "background-image": "url(" + t + ")"
        })
    })
  }), $j(".no-touch .product--zoom").length && (initProductHover(), $j(window).bind("reinitProductHover", function ()
                                                                                    {
    $j(".no-touch .product--zoom").length && initProductHover()
  })), initProductOptions(), $j(window).bind("reinitProductOptions", initProductOptions);
  var $mainMenu = $j(".mainMenu");
  $mainMenu.find(".dropdown-mega-menu").length && $mainMenu.find(".dropdown-mega-menu > ul:not(.image-links-layout)").each(function ()
                                                                                                                           {
    $j(this).find("a").each(function ()
                            {
      $j(this).hover(function ()
                     {
        var e = $j(this);
        if (e.parent().find("ul").length)
        {
          var t = e.parent().find("ul").first(),
              o = t.innerWidth() + t.offset().left,
              i = t.innerHeight() + t.offset().top,
              n = window.innerWidth,
              s = 0,
              l = null;
          if (t.hasClass("megamenu__submenu"))
          {
            if (t.parent().parent().hasClass("megamenu")) return !1;
            t.parent().parent().parent().parent().hasClass("megamenu") ? (n = (l = t.parent().parent().parent().parent()).offset().left + l.innerWidth(), s = l.offset().top + l.innerHeight(), (s -= i) < 0 && t.css("top", s - 5)) : t.parent().parent().parent().parent().parent().parent().hasClass("megamenu") && (n = (l = t.parent().parent().parent().parent().parent().parent()).offset().left + l.innerWidth(), s = l.offset().top + l.innerHeight(), (s -= i) < 0 && t.css("top", s - 5))
          }
          n < o && t.addClass("popup-left")
        }
      }, function () {})
    })
  }), $j(window).resize(function ()
                        {
    $j(".popup-left").length && $j(".popup-left").each(function ()
                                                       {
      $j(this).removeClass("popup-left"), $j(this).removeAttr("style")
    })
  });

  $j(".gift-guide-text").mouseover(function(){
    $j(this).addClass("hovered");
  });

  $j(".gift-guide-text").mouseout(function(){
    $j(this).removeClass("hovered");
  });


  // #show-all
  // #gift-guide-casual-wear-under-25
  // #gift-guide-casual-wear-between-25-50
  // #gift-guide-casual-wear-between-50-100
  // #gift-guide-casual-wear-over-100
  // Under $25
  // Between $25 - $50
  // Between $50 - $100
  // Over $100

  $j(".price-choice").click(function(){
    var getChoice = $j(this).data("price-value");
    var getCategory = $j('.gift-category-selected').data("category-value");
    $j(".price-choice").removeClass("selected-price");
    $j(this).addClass("selected-price");
    if(getChoice == "Under $25"){
      $j("#show-all, #gift-guide-cruiser-gear-between-25-50, #gift-guide-cruiser-gear-between-50-100, #gift-guide-cruiser-gear-over-100, #gift-guide-youth-wear-between-25-50, #gift-guide-youth-wear-between-50-100, #gift-guide-youth-wear-over-100, #gift-guide-snow-gear-between-25-50, #gift-guide-snow-gear-between-50-100, #gift-guide-snow-gear-over-100, #gift-guide-casual-wear-between-25-50, #gift-guide-casual-wear-between-50-100, #gift-guide-casual-wear-over-100, #gift-guide-street-gear-between-25-50, #gift-guide-street-gear-between-50-100, #gift-guide-street-gear-over-100,#gift-guide-offroad-gear-between-25-50, #gift-guide-offroad-gear-between-50-100, #gift-guide-offroad-gear-over-100").fadeOut(400).promise().done(function(){
        if(getCategory == "gift-guide-casual-wear"){
          $j("#gift-guide-casual-wear-under-25").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>CASUAL WEAR UNDER $25</h1>");
        }
        else if(getCategory == "gift-guide-street-gear"){
          $j("#gift-guide-street-gear-under-25").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title' >STREET GEAR UNDER $25</h1>");
        }
        else if(getCategory == "gift-guide-offroad-gear"){
          $j("#gift-guide-offroad-gear-under-25").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>OFF-ROAD GEAR UNDER $25</h1>");
        }
        else if(getCategory == "gift-guide-snow-gear"){
          $j("#gift-guide-snow-gear-under-25").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>SNOW GEAR UNDER $25</h1>");
        }
        else if(getCategory == "gift-guide-youth-wear"){
          $j("#gift-guide-youth-wear-under-25").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>YOUTH WEAR UNDER $25</h1>");
        }
        else if(getCategory == "gift-guide-cruiser-gear"){
          $j("#gift-guide-cruiser-gear-under-25").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>CRUISER GEAR UNDER $25</h1>");
        }
        $j(".njohn_product_grid_img_thumbs_list").css('width','50px');
      });
    }
    if(getChoice == "Between $25 - $50"){

      $j("#show-all, #gift-guide-cruiser-gear-under-25, #gift-guide-cruiser-gear-between-50-100, #gift-guide-cruiser-gear-over-100, #gift-guide-youth-wear-under-25, #gift-guide-youth-wear-between-50-100, #gift-guide-youth-wear-over-100, #gift-guide-snow-gear-under-25, #gift-guide-snow-gear-between-50-100, #gift-guide-snow-gear-over-100, #gift-guide-casual-wear-under-25, #gift-guide-casual-wear-between-50-100, #gift-guide-casual-wear-over-100, #gift-guide-street-gear-under-25, #gift-guide-street-gear-between-50-100, #gift-guide-street-gear-over-100, #gift-guide-offroad-gear-under-25, #gift-guide-offroad-gear-between-50-100, #gift-guide-offroad-gear-over-100").fadeOut(400).promise().done(function(){
        if(getCategory == "gift-guide-casual-wear"){
          $j("#gift-guide-casual-wear-between-25-50").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>CASUAL WEAR BETWEEN $25 - $50</h1>");
        }
        else if(getCategory == "gift-guide-street-gear"){
          $j("#gift-guide-street-gear-between-25-50").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>STREET GEAR BETWEEN $25 - $50</h1>");
        }
        else if(getCategory == "gift-guide-offroad-gear"){
          $j("#gift-guide-offroad-gear-between-25-50").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>OFF-ROAD GEAR BETWEEN $25 - $50</h1>");
        }
        else if(getCategory == "gift-guide-snow-gear"){
          $j("#gift-guide-snow-gear-between-25-50").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>SNOW GEAR BETWEEN $25 - $50</h1>");
        }
        else if(getCategory == "gift-guide-youth-wear"){
          $j("#gift-guide-youth-wear-between-25-50").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>YOUTH WEAR BETWEEN $25 - $50</h1>");
        }
        else if(getCategory == "gift-guide-cruiser-gear"){
          $j("#gift-guide-cruiser-gear-between-25-50").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>CRUISER GEAR BETWEEN $25 - $50</h1>");
        }
        $j(".njohn_product_grid_img_thumbs_list").css('width','50px');
      });
    }
    if(getChoice == "Between $50 - $100"){

      $j("#show-all, #gift-guide-cruiser-gear-under-25, #gift-guide-cruiser-gear-between-25-50, #gift-guide-cruiser-gear-over-100, #gift-guide-youth-wear-under-25, #gift-guide-youth-wear-between-25-50, #gift-guide-youth-wear-over-100, #gift-guide-snow-gear-under-25, #gift-guide-snow-gear-between-25-50, #gift-guide-snow-gear-over-100, #gift-guide-casual-wear-under-25, #gift-guide-casual-wear-between-25-50, #gift-guide-casual-wear-over-100, #gift-guide-street-gear-under-25, #gift-guide-street-gear-between-25-50, #gift-guide-street-gear-over-100, #gift-guide-offroad-gear-under-25, #gift-guide-offroad-gear-between-25-50, #gift-guide-offroad-gear-over-100").fadeOut(400).promise().done(function(){
        if(getCategory == "gift-guide-casual-wear"){
          $j("#gift-guide-casual-wear-between-50-100").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>CASUAL WEAR BETWEEN $50 - $100</h1>");
        }
        else if(getCategory == "gift-guide-street-gear"){
          $j("#gift-guide-street-gear-between-50-100").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>STREET GEAR BETWEEN $50 - $100</h1>");
        }
        else if(getCategory == "gift-guide-offroad-gear"){
          $j("#gift-guide-offroad-gear-between-50-100").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>OFF-ROAD GEAR BETWEEN $50 - $100</h1>");
        }
        else if(getCategory == "gift-guide-snow-gear"){
          $j("#gift-guide-snow-gear-between-50-100").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>SNOW GEAR BETWEEN $50 - $100</h1>");
        }
        else if(getCategory == "gift-guide-youth-wear"){
          $j("#gift-guide-youth-wear-between-50-100").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>YOUTH WEAR BETWEEN $50 - $100</h1>");
        }
        else if(getCategory == "gift-guide-cruiser-gear"){
          $j("#gift-guide-cruiser-gear-between-50-100").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>CRUISER GEAR BETWEEN $50 - $100</h1>");
        }
        $j(".njohn_product_grid_img_thumbs_list").css('width','50px');
      });
    }
    if(getChoice == "Over $100"){

      $j("#show-all, #gift-guide-cruiser-gear-under-25, #gift-guide-cruiser-gear-between-25-50, #gift-guide-cruiser-gear-between-50-100, #gift-guide-youth-wear-under-25, #gift-guide-youth-wear-between-25-50, #gift-guide-youth-wear-between-50-100, #gift-guide-snow-gear-under-25, #gift-guide-snow-gear-between-25-50, #gift-guide-snow-gear-between-50-100, #gift-guide-casual-wear-under-25, #gift-guide-casual-wear-between-25-50, #gift-guide-casual-wear-between-50-100, #gift-guide-street-gear-under-25, #gift-guide-street-gear-between-25-50, #gift-guide-street-gear-between-50-100, #gift-guide-offroad-gear-under-25, #gift-guide-offroad-gear-between-25-50, #gift-guide-offroad-gear-between-50-100").fadeOut(400).promise().done(function(){
        if(getCategory == "gift-guide-casual-wear"){
          $j("#gift-guide-casual-wear-over-100").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>CASUAL WEAR OVER $100</h1>");
        }
        else if(getCategory == "gift-guide-street-gear"){
          $j("#gift-guide-street-gear-over-100").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>STREET GEAR OVER $100</h1>");
        }

        else if(getCategory == "gift-guide-offroad-gear"){
          $j("#gift-guide-offroad-gear-over-100").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>OFF-ROAD GEAR OVER $100</h1>");
        }
        else if(getCategory == "gift-guide-snow-gear"){
          $j("#gift-guide-snow-gear-over-100").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>SNOW GEAR OVER $100</h1>");
        }
        else if(getCategory == "gift-guide-youth-wear"){
          $j("#gift-guide-youth-wear-over-100").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>YOUTH WEAR OVER $100</h1>");
        }
        else if(getCategory == "gift-guide-cruiser-gear"){
          $j("#gift-guide-cruiser-gear-over-100").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>CRUISER GEAR OVER $100</h1>");
        }
        $j(".njohn_product_grid_img_thumbs_list").css('width','50px');
      });
    }

    if(getChoice == "Show All"){

      $j("#gift-guide-cruiser-gear-under-25, #gift-guide-cruiser-gear-between-25-50, #gift-guide-cruiser-gear-between-50-100, #gift-guide-cruiser-gear-over-100, #gift-guide-youth-wear-under-25, #gift-guide-youth-wear-between-25-50, #gift-guide-youth-wear-between-50-100, #gift-guide-youth-wear-over-100 ,#gift-guide-snow-gear-under-25, #gift-guide-snow-gear-between-25-50, #gift-guide-snow-gear-between-50-100, #gift-guide-snow-gear-over-100, #gift-guide-casual-wear-under-25, #gift-guide-casual-wear-between-25-50, #gift-guide-casual-wear-between-50-100, #gift-guide-casual-wear-over-100, #gift-guide-street-gear-under-25, #gift-guide-street-gear-between-25-50, #gift-guide-street-gear-between-50-100, #gift-guide-street-gear-over-100, #gift-guide-offroad-gear-under-25, #gift-guide-offroad-gear-between-25-50, #gift-guide-offroad-gear-between-50-100, #gift-guide-offroad-gear-over-100").fadeOut(400).promise().done(function(){
        if(getCategory == "gift-guide-casual-wear"){
          $j("#show-all").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>CASUAL WEAR</h1>");
        }
        else if(getCategory == "gift-guide-street-gear"){
          $j("#show-all").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>STREET GEAR</h1>");
        }
        else if(getCategory == "gift-guide-offroad-gear"){
          $j("#show-all").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>OFF-ROAD GEAR</h1>");
        }
        else if(getCategory == "gift-guide-snow-gear"){
          $j("#show-all").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>SNOW GEAR</h1>");
        }
        else if(getCategory == "gift-guide-youth-wear"){
          $j("#show-all").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>YOUTH WEAR</h1>");
        }
        else if(getCategory == "gift-guide-cruiser-gear"){
          $j("#show-all").fadeIn(400);
          $j(".price-category>h1").html("<h1 class = 'gift-guide-big-title'>CRUISER GEAR</h1>");
        }
        $j(".njohn_product_grid_img_thumbs_list").css('width','50px');
      });
    }
  });


  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname && links[i].hostname != "") {
      links[i].target = '_blank';
    }
  }

  $j('.availability-selector').click(function(){

    $j('.availability-selector').removeClass('active');
    $j(this).addClass('active');
    var getClass = $j(this).data('selected-table');

    $j('.ecu-availability').hide();
    $j('.'+getClass).show(300);

  });
  
  //   FOR MOTO TIRES PAGE
  // $j('.tires-availability-selector').click(function(){

  //   $j('.tires-availability-selector').removeClass('active');
  //   $j(this).addClass('active');
  //   var getClass = $j(this).data('selected-table');

  //   $j('.tires-availability').hide();
  //   $j('.'+getClass).show(300);

  // });

   $j('.tires-availability-selector').click(function(){

    $j('.tires-availability-selector').removeClass('active');
    $j(this).addClass('active');
    // var getClass = $j(this).data('selected-table');
    var getChild = $j(this).children('.tiresSubMenu');

    $j('.tiresSubMenu').hide();
    // $j('.'+getClass).show(300);

    getChild.slideToggle( "slow", function() {
        // Animation complete.


    });

  });

  $j('.dropdownTireBrands .dropdown').click(function(){

    var parent_child = $(this);
    var child_content = parent_child.children('.dropdown-content');

    

    if(parent_child.hasClass('collapsed'))
    {
      child_content.slideUp();
    }
    else
    {
      $j('.dropdown-content').hide();
      child_content.slideDown();
    }

        

     // parent_child.toggleClass('collapsed');
    
    // if(parent_child.hasClass('collapsed')){
    //   parent_child.children('span.material-icons').html('keyboard_arrow_right');
    // }else{
    //   parent_child.children('span.material-icons').html('keyboard_arrow_down');
    // }

  });

  $j('.subscribe-moto-service-btn').click(function(){
    $j(this).hide();
    $j('.embedded-google-forms').fadeIn(800);

  });
  
  $j('.reviews-custom-slick-slider').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll:1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover:true,
    infinite:true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 525,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $j( document ).on( "load", function() {
    $j('.reviews-custom-slick-slider .slick-arrow').hide();

  });
  $j( document ).ready(function() {
    $j('.selected-price').trigger('click');
    $j('.reviews-custom-slick-slider .slick-arrow').hide();
    $j('.reviews-section').mouseover(function(){
      $j('.reviews-custom-slick-slider .slick-arrow').show();
    })
    .mouseout(function(){
      $j('.reviews-custom-slick-slider .slick-arrow').hide();

    });
  });

  $j('.show-more-reviews-btn').click(function(){

    if($j(this).hasClass("show")){
      $j('.second-row').fadeOut(300);
      $j(this).removeClass("show");
      $j('.service-show-more-btn').text("Show More");
    }
    else{
      $j('.second-row').fadeIn(300);
      $j(this).addClass("show");
      $j('.service-show-more-btn').text("Show Less");
    }
  });



  $j('.shopping-cart-btns .cart-btn').on('click', function(e){
    e.preventDefault();
    $j('.shopping-cart-btns .cart-btn').removeClass('active');
    $j(this).addClass('active');
  });

  // store values on an array based on the SETTINGS PICKUP SKU LISTS
  var pickup_sku_list = "";
  var pickup_only_sku_list = "144256,148885,144258,873-0028,144261,166366,170364,Service-A1,Service-A2,Service-A3,Service-A4,Service-B1,Service-B3,Service-B4,Service-B5,Service-B6,Service-B7,Service-B8,Service-B9,Service-C1,Service-C2,Service-C3,104121,104068,107319,109911,100949,101667,108093,103243,49-2285,49-2286,49-2261,49-2269,Service-D1,Service-D2,Service-D3,Service-D4,Service-D5,Bstone190,Bstone180,PR6180SET,PR6190SET,MX33Set,MAXXRear11019,MAXXFRT21,MAXXRear18,Bstone190SET,Bstone180SET,Service-B8,Service-B9,Service-B10,Q5S180SET,Q5S190SET,RS4180SET,RS4190SET,GPR180SET,GPR190SET,Q5180SET,Q5190SET,87-4914,87-4916,87-4917,87-4902,87-4904,87-4900,87-4903,87-4909,87-4905,87-4915,87-4906,87-4918,87-4913,87-4912,87-4919,87-4908,87-4907,87-4901,87-4910,87-93745,87-93744,87-93747,87-93762,87-93740,87-93743,87-93749,87-93755,87-93753,87-93754,87-93751,87-93759,87-93758,87-93750,87-93757,Service-A5,Service-A6,Service-A7,S23-F120,S23-R180,S23-R190,S23-180Set,S23-190Set,0301-0974-PU,0301-0975-PU,0302-1711-PU,0302-1712-PU,0302-1713-PU,0302-1714-PU,0302-1716-PU,0302-1717-PU,0302-1718-PU,PV4-140,PV4-150,PV4-180,PV4-190,PV4-200";

  // store values on an array based on the pickup_sku_list VARIABLES
  var pickup_sku_list_arr = [];
  var pickup_only_sku_list_arr = [];
  var pickup_sku_list_arr = pickup_sku_list.split(",");
  var pickup_only_sku_list_arr = pickup_only_sku_list.split(",");

  // array for trimmed values of the PICKUP SKU LISTS
  var pickup_sku_list_arr2 = [];
  var pickup_only_sku_list_arr2 = [];

  var item_onCart_vid = [];
  var item_onCart = [];
  var pickup_onCart = [];
  var pickupOnly_onCart = [];


  // trim each array values to remove whitespaces
  for(var pickVal in pickup_sku_list_arr)
  {
      var thisPickVal = pickup_sku_list_arr[pickVal];
      thisPickVal = thisPickVal.trim();
      pickup_sku_list_arr2.push(thisPickVal);
  }

  for(var pickOnVal in pickup_only_sku_list_arr)
  {
      var thisPickOnVal = pickup_only_sku_list_arr[pickOnVal];
      thisPickOnVal = thisPickOnVal.trim();
      pickup_only_sku_list_arr2.push(thisPickOnVal);
  }

  // remove null, undefined and "" on array values
  pickup_sku_list_arr2 = pickup_sku_list_arr2.filter(function(e){ return e === 0 || e });
  pickup_only_sku_list_arr2 = pickup_only_sku_list_arr2.filter(function(e){ return e === 0 || e });


  var params = {
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(line_item) {
      let hasPickup = false;
      var getPickupList = $j('#proceed-pickup').data('elpickup');
      for (var item in line_item.items) {
        let sku = line_item.items[item].sku;
        item_onCart.push(sku);
        item_onCart_vid.push(line_item.items[item].variant_id);
        if(getPickupList.includes(sku)){
          pickup_onCart.push(sku);
        }
        if(pickup_only_sku_list_arr2.includes(sku)){
          pickupOnly_onCart.push(sku);
        }
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      console.log(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);

//         console.log("pickup on CART:", pickup_onCart);
//         console.log("pickup ONLY on CART:", pickupOnly_onCart);
//         console.log("items on CART:", item_onCart);
//         console.log("Pickup ARR:", pickup_sku_list_arr2);
//         console.log("Pickup ONLY ARR:", pickup_only_sku_list_arr2);

  // ON CART PAGE: PICKUP ORDER BUTTON
  $j('#proceed-pickup').on('click',function(e){
    e.preventDefault();
    let hasShip = false;
    for (var i in item_onCart) {
      // check if cart page also contains SHIPPING ONLY items
      if(!pickup_onCart.includes(item_onCart[i]) && !pickupOnly_onCart.includes(item_onCart[i])){
        hasShip = true;
      }
    } 
    // if cart page contains SHIPPING ONLY items
    if(hasShip)
    {
      $j('#pickupConfirmModal').modal('show'); // show warning prompt modal
      
      if(pickup_onCart.length <= 0 && pickupOnly_onCart.length <= 0)  // if it contains SHIPPING ONLY items and NO PICKUP ELIGIBLE items
      {
        $j('.pickupButton-pickupAndShipItems').hide();  // PICKUP ORDER: Has Shipping Only item(s)
        $j('.pickupButton-pickupAndShipItemsButton').hide(); // PICKUP ORDER: Yes, I Understand button
        $j('.shipButton-pickupAndShipItems').hide(); // SHIP ORDER: Has Eligible for Pickup item(s)
        $j('.shipButton-pickupAndShipItemsButton').hide(); // SHIP ORDER: Yes, I Understand button
        $j('.shipButton-pickupOnly').hide(); // SHIP ORDER: Has Pickup Only item(s)
        $j('.shipButton').hide(); // SHIPPING ORDER: Modal Header Title: SHIPPING ORDER
        $j('.noship').hide(); // SHIP ORDER: Has no SHIPPING item(s)
        $j('.nopickup').show(); // PICKUP ORDER: has NO PICKUP item(s)
        $j('.pickupButton').show(); // PICKUP ORDER: Modal Header Title: PICKUP ORDER
      }
      else  // ELSE if it contains SHIPPING ONLY items AND any PICKUP ELIGIBLE items
      {
        $j('.shipButton-pickupAndShipItems').hide();  // SHIP ORDER: Has Eligible for Pickup item(s)
        $j('.shipButton-pickupAndShipItemsButton').hide(); // SHIP ORDER: Yes, I Understand button
        $j('.shipButton-pickupOnly').hide(); // SHIP ORDER: Has Pickup Only item(s)
        $j('.shipButton').hide(); // SHIPPING ORDER: Modal Header Title: SHIPPING ORDER
        $j('.noship, .nopickup').hide(); // SHIP ORDER: Has no SHIPPING item(s) or no PICKUP item(s)
        $j('.pickupButton-pickupAndShipItems').show(); // PICKUP ORDER: Has Shipping Only item(s)
        $j('.pickupButton-pickupAndShipItemsButton').show(); // PICKUP ORDER: Yes, I Understand button
        $j('.pickupButton').show(); // PICKUP ORDER: Modal Header Title: PICKUP ORDER
      } 
    } 
    // ELSE if cart page DOES NOT CONTAIN SHIPPING ONLY items and it's all PICKUP ELIGIBLE items
    else 
    {
      $j('#proceedPickup').click(); // next function
    }
  });
 
  $j('#pickup-button, #pick-up-now button').on('click',function(e){
    e.preventDefault();
    let qty = $j('#pickup-qty').val();
    let variant_id = $j(this).data('variantid');
    let line_items = [{variant_id: variant_id, quantity: qty}];
    $j.ajax({
      url: 'https://images.motorhelmets.com/shopify/draft-pickup-order.php',
      type: 'POST',
      dataType: 'json',
      headers: {
        'X-Pickup-Secret': 'mh_sec_e8b417c2f09d4351a96c3482701bcf5e93a7d182'
      },
      data: {line_items: line_items, store: 'motorhelmets'},
      beforeSend: function () {
        pickupLoader();
      },
      success: function (data) {
        let draft_order = data.draft_order;
        if("error" in draft_order){
          console.log("ERROR",draft_order.error);
        } else if("invoiceUrl" in draft_order){
          window.location.href = draft_order.invoiceUrl;
        }
        pickupLoader("off");
      },
      error: function(data){
        pickupLoader("off");
        $j('#pickupOptionModal').modal('hide');
        $j('#errorServerModal').modal('show');
      }
    });
  });

  // after the POP-UP MESSAGE: Yes, I Understand, go to checkout for PICKUP
  var rem_item = {};
  $j('#proceedPickup').on('click',function(e){
      var cartNote = $j('#note').val();
      var discPercent = "15";
      var discCode = "15OFFPICKUP23";    
    e.preventDefault();
    jQuery.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(line_item) {
        let draftItem = [];
        let back_item = {};
        for (var item in line_item.items) {
          let sku = line_item.items[item].sku;
          if(pickup_onCart.includes(sku) || pickupOnly_onCart.includes(sku)){
            draftItem.push({ variant_id: line_item.items[item].variant_id, quantity: line_item.items[item].quantity });
            back_item[line_item.items[item].variant_id] = line_item.items[item].quantity;
            rem_item[line_item.items[item].variant_id] = 0;
            toCookie(line_item.items[item].variant_id+":"+line_item.items[item].quantity);
          }
        }
        
        $j.ajax({
          url: 'https://images.motorhelmets.com/shopify/draft-pickup-order.php',
          type: 'POST',
          dataType: 'json',
          headers: {
            'X-Pickup-Secret': 'mh_sec_e8b417c2f09d4351a96c3482701bcf5e93a7d182'
          },
          data: {line_items: draftItem, note: cartNote, dper: discPercent, dcode: discCode, store: 'motorhelmets'},
          beforeSend: function () {
            preloader();
          },
          success: function (data) {
            let draft_order = data.draft_order;
            let inUrl = draft_order.invoiceUrl;
            if("error" in draft_order){
              console.log("ERROR",draft_order.error);
               console.log("STEP 1: ", "This happened.");
              jQuery.post('/cart/update.js', {updates: back_item});
            } else if("invoiceUrl" in draft_order){
              console.log("STEP 2: ", "This happened.");
              console.log("INVOICE URL: ", inUrl);
              window.location.href = draft_order.invoiceUrl;
            }
            preloader("off");

          },
          error: function(data){
            jQuery.post('/cart/update.js', {updates: back_item});
            console.log("STEP 3: ", "This happened.");
            console.log("ERROR",data);
            preloader("off");
            $j('#errorServerCartModal').modal('show');
          }
        });

        // $j.ajax({
        //   url: 'https://osomnimedia.com/api/shopify-apps/requests/draft-pickup-delete.php',
        //   type: 'POST',
        //   dataType: 'json',
        //   data: {draft_order_id: '582237257805', store: 'motorhelmets'},
        //   success: function (data) {
        //     let out = JSON.parse(data);
        //     console.log("STEP 4: ", "This happened.");
        //   },
        //   error: function(data){
        //     console.log("ERROR",data);
        //     console.log("STEP 5: ", "This happened.");
        //   }
        // });
        // if(rem_item.length) jQuery.post('/cart/update.js', {updates: rem_item}); // remove the product variant on the cart
      },
      error: function(XMLHttpRequest, textStatus) {
        console.log(XMLHttpRequest, textStatus);
        console.log("STEP 6: ", "This happened.");
        jQuery.post('/cart/update.js', {updates: back_item});
      }
    });
    // console.log("STEP 7: ", "This happened.");
    // jQuery.post('/cart/update.js', {updates: rem_item}); // remove the product variant on the cart
  });
  
  // ON CART PAGE: SHIP ORDER BUTTON 
  $j('#proceed-ship').on('click',function(e){
    e.preventDefault();
    let hasPickup = false;
    let hasPickupOnly = false;
    for (var i in item_onCart) {
      if(pickupOnly_onCart.includes(item_onCart[i])){
        hasPickupOnly = true;
      }
      if(pickup_onCart.includes(item_onCart[i])){
        hasPickup = true;
      }
    }
    if(hasPickupOnly && hasPickup)
    {
          $j('#pickupConfirmModal').modal('show'); // show warning prompt modal
          $j('.pickupButton-pickupAndShipItems').hide(); // PICKUP ORDER: Has Shipping Only item(s)
          $j('.pickupButton-pickupAndShipItemsButton').hide(); // PICKUP ORDER: Yes, I Understand button
          $j('.shipButton-pickupAndShipItems').hide(); // SHIP ORDER: Has Eligible for Pickup item(s)
          $j('.nopickup, .noship').hide(); // SHIP ORDER: Has no SHIPPING item(s) or no PICKUP item(s)
          $j('.shipButton-pickupOnly').show(); // SHIP ORDER: Has Pickup Only item(s)
          $j('.shipButton-pickupAndShipItemsButton').show(); // SHIP ORDER: Yes, I Understand button
          $j('.shipButton').show(); // SHIPPING ORDER: Modal Header Title: SHIPPING ORDER
    }
    else if(hasPickup)
    {
         $j('#pickupConfirmModal').modal('show'); // show warning prompt modal
         $j('.pickupButton-pickupAndShipItems').hide(); // PICKUP ORDER: Has Shipping Only item(s)
         $j('.pickupButton-pickupAndShipItemsButton').hide(); // PICKUP ORDER: Yes, I Understand button 
         $j('.shipButton-pickupOnly').hide(); // SHIP ORDER: Has Pickup Only item(s)
         $j('.nopickup, .noship').hide(); // SHIP ORDER: Has no SHIPPING item(s) or no PICKUP item(s)
         $j('.shipButton-pickupAndShipItems').show(); // SHIP ORDER: Has Eligible for Pickup item(s)
         $j('.shipButton-pickupAndShipItemsButton').show(); // SHIP ORDER: Yes, I Understand button
         $j('.shipButton').show(); // SHIPPING ORDER: Modal Header Title: SHIPPING ORDER
    } 
    else if(hasPickupOnly)
    {
        $j('#pickupConfirmModal').modal('show'); // show warning prompt modal
        if(pickupOnly_onCart.length == item_onCart.length ) 
        {
          $j('.pickupButton-pickupAndShipItems').hide(); // PICKUP ORDER: Has Shipping Only item(s)
          $j('.pickupButton-pickupAndShipItemsButton').hide(); // PICKUP ORDER: Yes, I Understand button  
          $j('.shipButton-pickupAndShipItems').hide(); // SHIP ORDER: Has Eligible for Pickup item(s)
          $j('.shipButton-pickupAndShipItemsButton').hide(); // SHIP ORDER: Yes, I Understand button
          $j('.shipButton-pickupOnly').hide(); // SHIP ORDER: Has Pickup Only item(s)
          $j('.nopickup').hide(); // PICKUP ORDER: has NO PICKUP item(s)
          $j('.noship').show(); // SHIP ORDER: Has no SHIPPING item(s)
          $j('.shipButton').show(); // SHIPPING ORDER: Modal Header Title: SHIPPING ORDER
        } 
        else 
        {
          $j('.pickupButton-pickupAndShipItems').hide(); // PICKUP ORDER: Has Shipping Only item(s)
          $j('.pickupButton-pickupAndShipItemsButton').hide(); // PICKUP ORDER: Yes, I Understand button  
          $j('.shipButton-pickupAndShipItems').hide(); // SHIP ORDER: Has Eligible for Pickup item(s)
          $j('.nopickup, .noship').hide(); // SHIP ORDER: Has no SHIPPING item(s) or no PICKUP item(s)
          $j('.shipButton-pickupOnly').show(); // SHIP ORDER: Has Pickup Only item(s)
          $j('.shipButton-pickupAndShipItemsButton').show(); // SHIP ORDER: Yes, I Understand button
          $j('.shipButton').show(); // SHIPPING ORDER: Modal Header Title: SHIPPING ORDER
        }
    }
    else 
    {
      // $j('#proceedShip').click(); // next function
      window.location.href = "/checkout";
    }
  });
  
  // after the POP-UP MESSAGE: Yes, I Understand, go to checkout for SHIP
  var pickrem_item = {};
  var rem_item = {};
  $j('#proceedShip').on('click',function(e){
    e.preventDefault();
    var params = {
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      beforeSend: function () {
        preloader();
      },
      success: function(line_item) {
        preloader("off");
        let draftItem = [];
        let back_item = {};
        let pickback_item = {};
        // let checkOrder = checkout.order;
        for (var item in line_item.items) {
          let sku = line_item.items[item].sku;
          if(pickupOnly_onCart.includes(sku)){
           rem_item[line_item.items[item].variant_id] = 0;
           pickback_item[line_item.items[item].variant_id] = line_item.items[item].quantity;
          }
          else
          {
             pickrem_item[line_item.items[item].variant_id] = 0;
             draftItem.push({ variant_id: line_item.items[item].variant_id, quantity: line_item.items[item].quantity });
             back_item[line_item.items[item].variant_id] = line_item.items[item].quantity;
             toCookie(line_item.items[item].variant_id+":"+line_item.items[item].quantity);
          }
        }

         $j.ajax({
          url: 'https://images.motorhelmets.com/shopify/draft-ship-orders.php',
          type: 'POST',
          dataType: 'json',
          headers: {
            'X-Pickup-Secret': 'mh_sec_e8b417c2f09d4351a96c3482701bcf5e93a7d182'
          },
          data: {line_items: draftItem, store: 'motorhelmets'},
          beforeSend: function () {
            preloader();
          },
          success: function (data) {
            let draft_order = data.draft_order;
            let inUrl = draft_order.invoiceUrl;
            if("error" in draft_order){
              console.log("ERROR",draft_order.error);
               console.log("STEP 1: ", "This happened.");
              jQuery.post('/cart/update.js', {updates: back_item});
            } else if("invoiceUrl" in draft_order){
              console.log("STEP 2: ", "This happened.");
              console.log("INVOICE URL: ", inUrl);
              window.location.href = draft_order.invoiceUrl;

              
            }
            preloader("off");

          },
          error: function(data){
            jQuery.post('/cart/update.js', {updates: back_item});
            console.log("STEP 3: ", "This happened.");
            console.log("ERROR",data);
            preloader("off");
            $j('#errorServerCartModal').modal('show');
          }
        });
        
        // jQuery.post('/cart/update.js', {updates: rem_item}).always(function() {
        //    window.location.href = "/checkout";
        // });
      },
      error: function(XMLHttpRequest, textStatus) {
        console.log(XMLHttpRequest, textStatus);
         jQuery.post('/cart/update.js', {updates: back_item});
         jQuery.post('/cart/update.js', {updates: pickback_item});
      }
    };
    jQuery.ajax(params);
    if(pickrem_item.length) jQuery.post('/cart/update.js', {updates: pickrem_item}); // remove the pickup only product on cart page
   
  });
  
  $j('#shipit').on('click',function(e){
    $j('.shopify-payment-button button.shopify-payment-button__button').click();
  });
  
  function toCookie(data){
    let cookiename = 'pickup_product';
    try {
      let item = data;
      let items = getCookie($j.cookie(cookiename));
      items = (items==null) ? items+"::" : '';
      $j.cookie(cookiename, items+item, { expires : 7, path: '/' });
    }
    catch (err) {
      console.log(err);
    }
  }

  function getCookie(c) {
    return String(c);
  }
  
  function preloader(play="on"){
    if(play=="on"){
      $j('#loader-wrapper').css("visibility","visible");
      $j('#loader-wrapper').css("opacity","1");
    } else {
      $j('#loader-wrapper').css("opacity","0");
      $j('#loader-wrapper').css("visibility","hidden");
    }
  }
  function pickupLoader(play="on"){
    if(play=="on"){
      $j('#pickup-button').html("Processing...");
    } else {
      $j('#pickup-button').html("<i class='simple-icon simple-icon-handbag'></i> PICK UP NOW!");
    }
  }
  
  let cookiename = 'pickup_product';
  try {
    let items = getCookie($j.cookie(cookiename));
    if(items!=null && items.length > 0){
      let line_items_arr = items.split('::');
      let add_item = {};
      for(let i in line_items_arr){
        let line_item = line_items_arr[i].split(':');
        if(!item_onCart_vid.includes(line_item[0])){
          add_item[i] = {"id":line_item[0],"quantity":line_item[1]};
        }
      }
      jQuery.post('/cart/add.js', {items: add_item})
      .always(function() {
        $j.cookie(cookiename, '', { expires : 7, path: '/' });
      });
    }

  }
  catch (err) {
    console.log(err);
  }
  var cart_change;
  $j('table .shopping-cart-table__input').on('change', 'input', function(e){
    let id = $j(this).data('id');
    let line = $j(this).data('line');
    let qty = $j(this).val();
    if(cart_change != null) clearTimeout(cart_change);
    cart_change = setTimeout(function(){autoCart(id, qty, line);}, 2000);
  });

  function autoCart(id, quantity, line){
    let up_item = {};
    up_item[id] = quantity;
    jQuery.post('/cart/update.js', {updates: up_item})
    .always(function() {
      
      var params = {
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(line_item) {
          let total_price = line_item.total_price;
          let line_price = line_item.items[line-1].line_price;
          $j('#subtotal td:nth-child(2), #grandtotal th:nth-child(2)').text(Shopify.formatMoney(total_price));
          $j('#item'+line+' .subtotal b').text(Shopify.formatMoney(line_price));
        },
        error: function(XMLHttpRequest, textStatus) {
          console.log(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(params);
      
    });
  }